var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAvatarWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#2653F1"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_51)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 17C32 25.2832 25.2832 32 17 32C8.71684 32 2 25.2832 2 17C2 8.71684 8.71684 2 17 2C25.2832 2 32 8.71684 32 17Z",
    fill: "#F9B233"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9767 25.7708C24.0328 24.5948 16.5737 22.0157 16.5737 22.0157C16.5737 22.0157 9.27008 24.8703 8.16804 25.7708C7.06855 26.6739 6.65784 32.3729 6.65784 32.3729H26.2726C26.2726 32.3729 25.918 26.9469 24.9767 25.7708Z",
    fill: "#003662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8873 23.3898C18.8873 23.3898 18.7317 24.1398 17.8465 24.5352C17.5276 24.6781 17.1118 26.4969 16.5761 26.4969C16.0098 26.4969 15.5787 24.6679 15.2547 24.5097C14.4154 24.1066 14.2674 23.3898 14.2674 23.3898C14.2674 23.3898 14.8312 22.2699 14.2674 20.9561C13.7037 19.6424 19.5787 19.3745 18.8899 20.9561C18.2011 22.5378 18.8899 23.3898 18.8899 23.3898H18.8873Z",
    fill: "#DDA778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8491 18.158C22.2802 16.2268 22.798 13.385 22.798 13.385C24.5787 9.40541 22.7317 3.4054 19.2802 5.24979C15.0098 1.34928 8.25467 6.80337 10.5404 13.3314C10.5404 13.3314 10.8159 16.3187 11.2598 18.2217C11.7598 20.362 15.446 21.9513 16.5736 22.0151C17.6986 22.0789 21.3924 20.2039 21.8491 18.1605V18.158Z",
    fill: "#281511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.107 14.5226C23.107 15.566 22.3672 16.9996 21.8697 16.9996C21.3723 16.9996 20.9667 16.1527 20.9667 15.1119C20.9667 14.0711 21.4769 13.5303 21.8697 13.2241C22.3519 12.8466 23.107 13.2241 23.107 14.5252V14.5226Z",
    fill: "#F9BB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1913 14.5226C10.1913 15.566 10.9311 16.9996 11.4285 16.9996C11.926 16.9996 12.3316 16.1527 12.3316 15.1119C12.3316 14.0711 11.8214 13.5303 11.4285 13.2241C10.9464 12.8466 10.1913 13.2241 10.1913 14.5252V14.5226Z",
    fill: "#F9BB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6706 6.25696C13.1681 6.25696 11.6196 8.71104 11.6196 12.3718V16.9559C11.6196 20.1447 15.3033 22.8718 16.4666 22.8718C17.6298 22.8718 21.7217 19.683 21.7217 16.6626V12.3718C21.7217 8.71104 20.1732 6.25696 16.6706 6.25696Z",
    fill: "#F9BB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7218 14.9848L22.0381 12.3139C22.0381 8.65319 20.1733 5.92615 16.6707 5.92615C13.1682 5.92615 11.4386 8.65319 11.4386 12.3139L11.6197 15.5716C11.6197 15.5716 12.0355 14.8726 11.9973 13.8394C11.9131 11.4899 13.5585 11.2807 15.4743 10.9134C18.4947 10.3369 19.3442 8.52564 19.3442 8.52564C19.3442 8.52564 20.334 8.85982 20.9667 10.3369C21.3748 11.2909 21.4718 12.7527 21.4386 13.3522C21.408 13.9491 21.7218 14.9848 21.7218 14.9848Z",
    fill: "#281511"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarWithBg);
export default __webpack_public_path__ + "static/media/defaultAvatarWithBg.73b9eed20f7e2940c0e4a7a61910b0b8.svg";
export { ForwardRef as ReactComponent };